import axios from 'axios'
import store from '@/store'
// import router from '@/router'

axios.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers.Authorization = `Bearer ${store.getters.token}`
  }
  return config
},
error => Promise.reject(error)
)

axios.interceptors.response.use(resp => {
  if (resp.headers.access_token) {
    store.commit('setToken', resp.headers.access_token)
  }
  return resp
}, function (error) {
  if (error.response.status === 401) {
    // var bookId = store.getters.currentUser.book_id
    store.commit('deleteToken')
    location.reload()
    // router.push({ name: 'Login', query: { relogin: true, redirect: window.location, bookId: bookId } })
  }
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/config/axios.js